export default class VerifyService {
  phone = '';
  code = ''; //验证码
  timer = null; //验证码计时器
  startTime = ''; //发送验证码时间戳
  maxTime = 180; //最大等待时间
  callback = null; //倒计时回调函数

  constructor() {
    return (VerifyService.instance = VerifyService.instance || this);
  }

  subscribe(callback) {
    this.callback = callback;
  }

  start() {
    this.startTime = Date.now();
    this.timer = setInterval(res => {
      let now = Date.now();
      let remainTime = this.maxTime * 1000 - (now - this.startTime);
      if (this.callback) {
        this.callback(~~(remainTime / 1000));
      }
      if (remainTime <= 0) {
        this.reset();
      }
    }, 200);
  }

  reset() {
    clearInterval(this.timer);
    this.timer = null;
    this.startTime = '';
    this.callback = null;
  }

}
